<template>
	<div>

		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="btn">
			<div class="jiams tj">
				<div>供应商：</div>
				<Select v-model="query.opers" multiple style="width:300px" max-tag-count='2' filterable='true' @on-change="onchangeSousuo1">
				        <Option v-for="item in opers" :value="item.value" :key="item.value">{{ item.label }}</Option>
				</Select>
			</div>
			<div class="comm tj">
				<div>设备：</div>
				<Select v-model="query.macs" multiple style="width:300px" max-tag-count='2' filterable='true' @on-change="onchangeSousuo2">
				        <Option v-for="item in macs" :value="item.value" :key="item.value">{{ item.label }}</Option>
				</Select>
			</div>
			<div class="time tj">
				<div>时间：</div>
				<div class="time-xz">
					<DatePicker type="datetime" placeholder="开始时间" v-model='kaishi' style="width: 200px" @on-change="onchangeKaishi" @on-ok="onok"  ></DatePicker>
					<div>--</div>
					<DatePicker type="datetime" placeholder="结束时间" v-model='jieshu' style="width: 200px" @on-change="onchangeJieshu" @on-ok="onok"  ></DatePicker>
				</div>
			</div>
		</div>

		<tongji :map="map"></tongji>
       <Table border ref="selection" :columns="columns12" :data="data6" @on-selection-change="selection" :loading="loading">

			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" @click="xiangqing(row)">详情</Button>
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" v-if="showPage" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	import tongji from '../../../comm/tongji.vue'
	export default {
		data() {
			return {
				showPage:true,
				loading:false,
				kaishi:'',
				jieshu:'',
				//设备列表
				macs: [
						/* {
							value: '1',
							label: 'New York'
						} */
					],
				//加盟商列表
				opers: [
						/* {
							value: '1',
							label: 'New York'
						} */
					],
				//总页数
				total: 100,
				columns12: [{
						title: '设备id',
						key: 'id',
						width:100
					},
					// {
					// 	title: '设备编号',
					// 	key: 'macCode'
					// },
					{
						title: '地址',
						key: 'address',
						width:150
					},
					{
						title: '微信交易金额(元)',
						key: 'wechatMoney',
						width:150,
						render: (h, params) => {
							return h("div",params.row.wechatMoney)
						}
					},
					{
						title: '微信退款金额(元)',
						key: 'wechatRefundMoney',
						width:150,
						render: (h, params) => {
							return h("div",params.row.wechatRefundMoney)
						}
					},
					{
						title: '支付宝交易金额(元)',
						key: 'alipayMoney',
						width:150,
						render: (h, params) => {
							return h("div",params.row.alipayMoney)
						}
					},
					{
						title: '支付宝退款金额(元)',
						key: 'alipayRefundMoney',
						width:150,
						render: (h, params) => {
							return h("div",params.row.alipayRefundMoney)
						}
					},
					// {
					// 	title: '小善金额(元)',
					// 	key: 'xiaoshanMoney',
					// 	render: (h, params) => {
					// 		//return h("div",{style:{'background-color':'red',height:'100%',width:'100%'}},"停用")
					// 		return h("div",params.row.xiaoshanMoney)
					// 	}
					// },
					// {
					// 	title: '小善退款(元)',
					// 	key: 'xiaoshanRefundMoney',
					// 	render: (h, params) => {
					// 		return h("div",params.row.xiaoshanRefundMoney)
					// 	}
					// },

					{
						title: '环保积分交易金额(元)',
						key: 'xiaojieMoney',
						width:200,
						render: (h, params) => {
							return h("div",params.row.xiaojieMoney)
						}
					},
					{
						title: '环保积分退款金额(元)',
						key: 'xiaojieRefundMoney',
						width:200,
						render: (h, params) => {
							return h("div",params.row.xiaojieRefundMoney)
						}
					},
					{
						title: '总金额(元)',
						key: 'totalMoney',
						width:150,
						render: (h, params) => {
							return h("div",params.row.totalMoney)
						}
					},
					{
						title: '抽成金额(元)',
						key: 'rakeMoney',
						width:150,
						render: (h, params) => {
							return h("div",params.row.rakeMoney)
						}
					},
					{
						title: '操作',
						slot: 'action',
						width: 80,
						align: 'center'
					}
				],
				data6: [
					/* {
					id: '1',
					name: 'XXX机器人',
					address: '渝北区泰山大道东段',
					isRefrigerate: '冷藏',
					startUsing: '启用',
					state: '正常',
					isStockout: '正常',
					useOperOperator: "XXXX",
					createdTime: '2010-10-10'
				} */
				],
				query: {
					page: '0',
					size: '10',
					opers:[],
					macs:[],
					kaishiTime:'',
					//结束时间
					jieshuTime:'',
				},
				map:{
					yearMoney:'--',
					monthMoney:'--',
					dayMoney:'--'
				}
			}
		},
		methods: {

			ret() { //返回上一页
				this.$router.go(-1)
			},
			xiangqing(item){
				let _this=this
				this.$router.push({
					name: 'jm/platform/finance/operList',
					query: {
						kaishi:_this.query.kaishiTime+'',
						jieshu:_this.query.jieshuTime+'',
						opers:_this.query.opers,
						macId:item.id
					}
				})
			},
			//查询条件
			onchangeKaishi(time){
				let _this=this
				_this.query.kaishiTime=time
			},
			onchangeJieshu(time){
				let _this=this
				_this.query.jieshuTime=time
			},
			onok(){
				let _this=this
				_this.query.page=0
				let ks=new Date(_this.query.kaishiTime).getTime()
				let js=new Date(_this.query.jieshuTime).getTime()
				let d=Math.floor((js-ks)/(24*3600*1000))
				console.log(d)
				if(d<=31){

					//重新渲染子组件
					this.showPage = false
					this.$nextTick(() => {
						this.showPage = true
					})
					_this.ajaxPage()
					this.queryOperStatistics()
				}else{

					_this.$Message.error('查询时间支持的最大跨度为31天!');
				}

			},
			onclear(){
				let _this=this
				_this.query.page=0
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				})
				_this.ajaxPage()
				this.queryOperStatistics()
			},
			onchangeSousuo1(){
				let _this=this
				_this.query.page=0
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				})
				_this.ajaxPage()
				_this.queryMacs()
			    this.queryOperStatistics()
			},
			onchangeSousuo2(){

				let _this=this
				_this.query.page=0
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				})
				_this.ajaxPage()
			    this.queryOperStatistics()
			},
			//查询条件
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fin/report/comm/page/oper/earnings/mac',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.macs.totalElements
						_this.data6 = data.macs.content
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })

			},

			queryOper(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/plat/oper/page',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						let items = data.opers.content
						for (let i = 0; i < items.length; i++) {
							let a={
								value: '',
								label: ''
							}
							a.value=items[i].id
							a.label=items[i].companyName
							_this.opers.push(a)
						}
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			},
			queryMacs(){
				let _this=this
				let q={
					page:0,
					size:1000,
					ids:[]
				}
				q.ids=_this.query.opers
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/fac/mac/leave/factory/page/jm/oper1',
					data: q,
					_this: _this,
					success: function(data) {
						let items = data.macLeaveFactorys.content
						_this.macs=[]
						for (let i = 0; i < items.length; i++) {
							let a={
								value: '',
								label: ''
							}
							a.value=items[i].id
							a.label=items[i].macCode
							_this.macs.push(a)
						}
					}
					//假设后台需要的是表单数据这里你就可以更改
				  })

			},
			queryOperStatistics(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fin/report/comm/page/jm/statistics/oper',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.map = data.map
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })

			},



		},
		components: {
			page,tongji
		},
		created() {
			let _this=this
			_this.kaishi=_this.$route.query.kaishi
			_this.jieshu=_this.$route.query.jieshu
			_this.query.kaishiTime=_this.$route.query.kaishi
			_this.query.jieshuTime=_this.$route.query.jieshu
			//let operId=_this.query.opers.push(this.$route.query.operId+'')
			let operId=this.$route.query.operId+''
			_this.operId=operId
			_this.query.opers=[]
			_this.query.opers.push(operId)

			// _this.ajaxPage()
			_this.queryOper()
			//_this.queryOperStatistics()
		},
		//设置返回不刷新数据
		beforeRouteLeave(to, from, next) {
			from.meta.keepAlive = false;
      this.$destroy();
			to.meta.keepAlive = true;
      next()
			// if(to.name=='jm/platform/jmFinanceHome/oper/earnings' || to.name=='jm/finance/checking/oper'){
			// 	from.meta.keepAlive = false;
			// 	this.$destroy(); //销毁B的实例
			//     to.meta.keepAlive = true;
			// 	next();//当我们前进的不是C时我们让B页面刷新
			// }else{
			//     from.meta.keepAlive = true;
			// 	to.meta.keepAlive = true;
			// 	next()
			// }
		},
	}
</script>
<style scoped="scoped" lang="less">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.tongji {
		width: 100%;
		display: flex;
		margin:10px;
		.item{
		    margin: 0px 20px 0px 20px;
			display: flex;
			font-size: 20px;
		}
	}

	.checkbox {
		display: flex;
		justify-content: flex-end;
	}

	span {
		color: #007AFF;
	}

	.btn {
		margin: 20px;
		display: flex;
		.tj{
			display: flex;
			align-items: center;
		}
		.time{
			display: flex;
			.time-xz{
				display: flex;
			    align-items: center;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/finance/operEarningsMac.vue